module.exports = __webpack_public_path__ + "static/img/nomad.f841aa1.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/nomad.png
// module id = Vmle
// module chunks = 1